import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/lm10_kingleo?igsh=ZmJuNWt1NjV1MjFv" className="home__social-icon" target="_blank">
        <i class="uil uil-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/nilanjan-bhattacharya-401988208" className="home__social-icon" target="_blank">
        <i class="uil uil-linkedin-alt"></i>
        </a>
        <a href="https://github.com/Nilanjan10" className="home__social-icon" target="_blank">
        <i class="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social